import { z } from 'zod';

/** Три рейтинговых вопроса NPS (шкала 1–10). Тексты синхронны с libs/telegram event-nps. */
export const EVENT_NPS_RATING_QUESTIONS = [
  {
    key: 'atmosphereScore',
    label: 'Как тебе атмосфера на встрече — комфорт, дружелюбие, обстановка?',
  },
  {
    key: 'organizationScore',
    label: 'Как тебе организация — тайминг, локация, логистика?',
  },
  {
    key: 'valueScore',
    label: 'Насколько ценной была встреча — нетворкинг, знания, контакты?',
  },
] as const;

export const EventNpsPartialDto = z.object({
  atmosphereScore: z.number().int().min(1).max(10).nullable(),
  organizationScore: z.number().int().min(1).max(10).nullable(),
  valueScore: z.number().int().min(1).max(10).nullable(),
});

export type EventNpsPartialDto = z.infer<typeof EventNpsPartialDto>;

export const SubmitEventNpsInput = z.object({
  atmosphereScore: z.number().int().min(1).max(10),
  organizationScore: z.number().int().min(1).max(10),
  valueScore: z.number().int().min(1).max(10),
});

export type SubmitEventNpsInput = z.infer<typeof SubmitEventNpsInput>;
